//@ts-ignore
import VueJwtDecode from 'vue-jwt-decode';
import { ssmTokenService } from './token-service';
import { Tokenjwt } from '@/shared/dtos/Tokenjwt';

export default class JwtUtils {
    public jwtDecode(): Tokenjwt {
        if (ssmTokenService.getToken() !== null) {
            return new Tokenjwt(VueJwtDecode.decode(ssmTokenService.getToken()));
        }
        return new Tokenjwt();
    }

    public jwtIsAdmin(): boolean {
        if (ssmTokenService.getToken() !== null) {
            return new Tokenjwt(VueJwtDecode.decode(ssmTokenService.getToken())).role.toLocaleLowerCase() === "true";
        }
        return false;
    }

}
export const JwtService = new JwtUtils();